import React from "react";
import { useTranslation } from "react-i18next";
import { projectExpenseType as projectExpenseTypeValue } from "@planzone/dto";
import { ColorPicker } from "@common/colorPicker";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { Props } from "./types";
import { ColorPickerIcon } from "./colorPickerIcon";
import styles from "./styles.scss";

function ExpenseTypeCreation({ submit }: Props) {
  const { t } = useTranslation();
  const [projectExpenseType, setProjectExpenseType] = React.useState(
    projectExpenseTypeValue,
  );
  const [creatingType, setCreatingType] = React.useState(false);

  return creatingType ? (
    <div className={styles.form}>
      <VisibilitySwitch
        renderChildren={(isVisible, show, hide) => (
          <div className={styles.wrapper}>
            <div onClick={isVisible ? hide : show} className={styles.iconBox}>
              {projectExpenseType.color ? (
                <div
                  className={styles.icon}
                  style={{ backgroundColor: projectExpenseType.color }}
                />
              ) : (
                <ColorPickerIcon className={styles.icon} />
              )}
            </div>
            {isVisible && (
              <div className={styles.colorPicker}>
                <ColorPicker
                  color={projectExpenseType.color}
                  pick={(color) =>
                    setProjectExpenseType({ ...projectExpenseType, color })
                  }
                />
              </div>
            )}
          </div>
        )}
      />
      <input
        className={styles.input}
        value={projectExpenseType.name}
        placeholder={t(
          "projectBudgetSynthesis.expenses.creation.newExpenseType",
        )}
        onChange={({ target }) =>
          setProjectExpenseType({
            ...projectExpenseType,
            name: target.value,
          })
        }
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            e.stopPropagation();
            e.preventDefault();
            submit(projectExpenseType);
            setCreatingType(false);
            setProjectExpenseType(projectExpenseTypeValue);
          }
        }}
        autoFocus
      />
      <div
        className={styles.button}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          submit(projectExpenseType);
          setCreatingType(false);
          setProjectExpenseType(projectExpenseTypeValue);
        }}
      >
        {t("projectBudgetSynthesis.expenses.creation.createExpenseType")}
      </div>
    </div>
  ) : (
    <div
      className={styles.enableCreate}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        setCreatingType(true);
      }}
    >
      <div className={styles.plusSign}>+</div>
      <div>{t("projectBudgetSynthesis.expenses.creation.newExpenseType")}</div>
    </div>
  );
}

export { ExpenseTypeCreation };
